<template>
  <div class="wrapper">
    <dash-header></dash-header>
    <sidebar></sidebar>
    <div class="content-wrapper p-3">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-3">
            <div class="col-sm-12">
              <h1 class="m-0 text-bold mb-2" style="font-size: 35px">
                Investor
              </h1>
              <form
                action=""
                class="
                  form-inline
                  my-2 my-lg-0
                  w-100
                  d-flex
                  justify-content-between
                "
              >
                <div class="form-group">
                  <label
                    for="exampleFormControlSelect1"
                    style="font-weight: 600; color: rgba(0, 0, 0, 0.6)"
                    >Show</label
                  >
                  <select
                    class="form-control ml-2"
                    id="exampleFormControlSelect1"
                  >
                    <option>10</option>
                    <option>20</option>
                    <option>30</option>
                    <option>40</option>
                    <option>50</option>
                  </select>
                  <label
                    class="ml-2"
                    style="font-weight: 600; color: rgba(0, 0, 0, 0.6)"
                    >Entries</label
                  >
                </div>
                <input
                  class="form-control search-input__form"
                  style="border-radius: 10px"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  v-model="table.filter"
                />
                <!-- <div class="input-group-append">
                      <button type="submit" class="btn btn-default">
                        <i class="fas fa-search"></i>
                      </button>
                    </div> -->

                <!-- <button class="btn btn-outline-success my-2 my-sm-0" value="CARI" type="submit"><i class="fas fa-search"></i></button> -->
              </form>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-12"></div>
            <div class="card-body table-responsive p-0">
              <b-table
                hover
                :items="investors"
                :per-page="table.perPage"
                :current-page="table.currentPage"
                :fields="table.fields"
                id="investor-table"
              >
                <template #cell(No)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(investor_name)="data">
                  {{ data.item.name }}
                </template>
                <template #cell(email)="data">
                  {{ data.item.email }}
                </template>
                <template #cell(total_deposit)="data">
                  <span class="badge badge-success">${{ data.item.total_deposit }}</span>
                </template>
              </b-table>
              <p class="text-center" v-if="investors.length == 0">Data not available.</p>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="rows"
                :per-page="table.perPage"
                aria-controls="investor-table"
                class="my-3"
              >
              </b-pagination>
              <!-- <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <dash-footer></dash-footer> -->
  </div>
</template>
<script>
import DashHeader from "../../layouts/Header.vue";
// import DashFooter from "../../layouts/Footer.vue";
import Sidebar from "../../layouts/Sidebar.vue";
import axios from "axios";
export default {
  name: "Investor_list",
  components: {
    DashHeader,
    // DashFooter,
    Sidebar,
  },
  data() {
    return {
      investors: [],
      table: {
        perPage: 10,
        currentPage: 1,
        fields: [
          "No",
          {
            key: "investor_name",
            label: "Name",
            sortable: true,
          },
          {
            key:"email",
            label:"Email",
            sortable: false,
          },
          {
            key: "total_deposit",
            label: "Deposit Collect",
            sortable: true,
          },
          // {
          //   key: "broker_name",
          //   label: "Broker",
          //   sortable: false,
          // },
        ],
      },
    };
  },
  computed: {
    rows() {
			return this.investors.length
		}
  },
  async mounted() {
    await axios
      .get(`investor/${localStorage.user_id}/referral/`)
      .then((response) => {
        // console.log("Investor ", response.data.data);
        this.investors = response.data.data;
      })
      .catch(() => {
        // console.log("Error Investor: ", err.response);
      });
  },
};
</script>
<style scoped>
.dashboard__title {
  color: rgba(27, 18, 18, 0.6);
  font-size: 15px;
  font-weight: 700;
}
.dashboard__card {
  background: #3498db;
  border-radius: 15px;
}
.dashboard__heading {
  color: white;
  font-weight: 700;
  font-size: 32px;
  margin-left: 120px;
  margin-top: 10px;
}
.dashboard__caption {
  color: white;
  font-size: 20px;
  margin-top: 50px;
  text-align: center;
  font-weight: 600;
  margin-left: 20px;
}
.dashboard__frames {
  width: 230x;
  height: 200px;
  float: right;
  margin-top: -135px;
}
.broker-info__card {
  border-radius: 12px;
}
.broker-info__rectangle {
  background-color: #0047ffb2;
  height: 18px;
  width: 18px;
  position: relative;
}
.card-broker-info__heading {
  color: rgba(0, 0, 0, 0.6);
  font-size: 17px;
  position: absolute;
  margin-top: 0;
  margin-left: 32px;
  font-weight: 700;
}
.card-broker-info__caption {
  text-align: right;
  font-weight: 700;
  font-size: 30px;
  margin-right: 20px;
  margin-top: 20px;
}
.corporate-partner__card {
  border-radius: 15px;
}
.corporate-partner__heading {
  font-size: 27 px;
  font-weight: 600;
  margin-top: 20px;
  margin-left: 60px;
}
.corporate-partner__caption {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: 60px;
  font-weight: 500;
  margin-top: 10px;
}
.corporate-partner__button {
  border-radius: 6px;
  font-weight: 600;
  color: white;
  background-color: #3498db !important;
  font-size: 16px;
  float: right;
  margin-right: 145px;
  width: 130px;
  margin-top: 15px;
}
.corporate-partner__frames {
  width: 170px;
  height: 170px;
  float: right;
  margin-top: -150px;
  object-fit: cover;
}
</style>